import type { InjectionKey } from 'vue'

export interface IStorageService {
  get<T>(key: string): T | null
  set<T>(key: string, value: T): void
  remove(key: string): void
  clear(): void
}

export const STORAGE_SERVICE_KEY: InjectionKey<IStorageService> = Symbol('StorageService')
